exports.download = require('./lib/wget').download;
exports.request = require('./lib/wget').request;